module.exports = __webpack_public_path__ + "img/remote_background.ebc78395.jpg";